export default __webpack_public_path__ + "static/media/firmcare.b431e48d.png";